import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getDateLabelText } from '@hivebrite/utils';
import { FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { POSITIONS } from '@design-system/tooltip';
import { DatePicker } from './DatePicker';
import { BaseInput } from '../BaseInput';
const CalendarIcon = () => (_jsx(FontAwesomeIcon, { height: "16px", iconName: "calendar" }));
const Component = (_a, ref) => {
    var _b, _c;
    var { animate = true, arrayOfEnableDates, displayFormat = ((_c = (_b = window === null || window === void 0 ? void 0 : window.I18n) === null || _b === void 0 ? void 0 : _b.t) === null || _c === void 0 ? void 0 : _c.call(_b, 'date.formats.alt_format')) || 'Y/m/d', enableTime = false, icon = CalendarIcon, isStatic = false, label: initialLabel, locale = 'en-GB', maxDate, minDate, variant = 'normal', width = '100%' } = _a, props = __rest(_a, ["animate", "arrayOfEnableDates", "displayFormat", "enableTime", "icon", "isStatic", "label", "locale", "maxDate", "minDate", "variant", "width"]);
    const label = initialLabel
        ? getDateLabelText(initialLabel)
        : undefined;
    return (_jsx(BaseInput, Object.assign({}, props, { icon: icon, inputComponent: DatePicker, inputProps: {
            animate,
            arrayOfEnableDates,
            displayFormat,
            enableTime,
            locale,
            maxDate,
            minDate,
            isStatic,
        }, label: label, ref: ref, tooltipPosition: POSITIONS.BOTTOM, variant: variant, width: width })));
};
export const DatePickerInput = forwardRef(Component);
//# sourceMappingURL=index.js.map